// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RJe3","expireSoon":"styles_expireSoon__29N2r"};